import React from "react";
import home from "assets/img/home.png"
import gallery from "assets/img/gallery.png"

export default function Footer() {
  return (
    <>
      <div className="xl:block lg:block hidden xl:mb-12 z-50">
        <footer className="nav-menu fixed pb-4">
          <div className="container mx-auto">
            <div className="flex justify-center">
              <div className="bgblack-100 rounded-xl py-4">
                <div className="flex items-center w-full  justify-center">
                  <div className="px-4">
                    <div className="bgbutton p-2 rounded-lg">
                      <a href="/">
                        <img src={home} className="w-5" />
                      </a>
                    </div>
                  </div>
                  <div className="px-4 border-l border-r " style={{ borderColor: "#ffffff80" }}>
                    <ul className="">
                      <li className="text-white xl:text-sm lg:text-sm text-sm  font">
                        <a href="/project-highlight">
                          Project Highlights
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="px-4  border-r " style={{ borderColor: "#ffffff80" }}>
                    <ul className="">
                      <li className="text-white xl:text-sm lg:text-sm text-sm  font">
                        <a href="/location">
                          Location
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="px-4 border-r " style={{ borderColor: "#ffffff80" }}>
                    <ul className="">
                      <li className="text-white xl:text-sm lg:text-sm text-sm  font">
                        <a href="/master-plans">
                          Master Plan
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="px-4  border-r " style={{ borderColor: "#ffffff80" }}>
                    <ul className="text-center">
                      <li className="px-2 text-white text-center xl:text-sm lg:text-sm text-sm  font">
                        <a href="/tower">
                          Project Details
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="px-4  border-r " style={{ borderColor: "#ffffff80" }}>
                    <ul className="">
                      <li className="text-white xl:text-sm lg:text-sm text-sm  font">
                        <a href="/amenities">
                          Amenities 
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="px-4 border-r " style={{ borderColor: "#ffffff80" }}>
                    <ul className="">
                      <li className="text-white xl:text-sm lg:text-sm text-sm  font">
                      <a href="/Embassyonethane.pdf" target="_blank" rel="noopener noreferrer">
                        Collaterals 
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="px-4  border-r " style={{ borderColor: "#ffffff80" }}>
                    <ul className="">
                      <li className="text-white xl:text-sm lg:text-sm text-sm  font">
                        <a href="/walkthrough">
                        Walkthrough 
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="px-4 ">
                    <div className="bgbutton p-2 rounded-lg">
                      <a href="/gallery">
                        <img src={gallery} className="w-5" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div
          className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-blueGray-200 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap text-center lg:text-left">
            <div className="w-full lg:w-6/12 px-4">
              <h4 className="text-3xl font-semibold">Let's keep in touch!</h4>
              <h5 className="text-lg mt-0 mb-2 text-blueGray-600">
                Find us on any of these platforms, we respond 1-2 business days.
              </h5>
              <div className="mt-6 lg:mb-0 mb-6">
                <button
                  className="bg-white text-lightBlue-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-twitter"></i>
                </button>
                <button
                  className="bg-white text-lightBlue-600 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-facebook-square"></i>
                </button>
                <button
                  className="bg-white text-pink-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-dribbble"></i>
                </button>
                <button
                  className="bg-white text-blueGray-800 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-github"></i>
                </button>
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="flex flex-wrap items-top mb-6">
                <div className="w-full lg:w-4/12 px-4 ml-auto">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    Useful Links
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.creative-tim.com/presentation?ref=nr-footer"
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://blog.creative-tim.com?ref=nr-footer"
                      >
                        Blog
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.github.com/creativetimofficial?ref=nr-footer"
                      >
                        Github
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.creative-tim.com/bootstrap-themes/free?ref=nr-footer"
                      >
                        Free Products
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    Other Resources
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://github.com/creativetimofficial/notus-react/blob/main/LICENSE.md?ref=nr-footer"
                      >
                        MIT License
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/terms?ref=nr-footer"
                      >
                        Terms & Conditions
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/privacy?ref=nr-footer"
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/contact-us?ref=nr-footer"
                      >
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr className="my-6 border-blueGray-300" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center">
              <div className="text-sm text-blueGray-500 font-semibold py-1">
                Copyright © {new Date().getFullYear()} Notus React by{" "}
                <a
                  href="https://www.creative-tim.com?ref=nr-footer"
                  className="text-blueGray-500 hover:text-blueGray-800"
                >
                  Creative Tim
                </a>
                .
              </div>
            </div>
          </div>
        </div> */}
        </footer>
      </div>
    </>
  );
}
